// extracted by mini-css-extract-plugin
export default {"menuBlock":"wI-z","title":"xI-z","nav":"yI-z","flexCell":"zI-z","facetLink":"AI-z"};